import React, { useState } from 'react';

import classNames from 'classnames';

import LoadingSpinner from '../../common/LoadingSpinner';
import Slices from '../../Offers/Slices';
import styles from '../../assets/css/booking.module.css';

import { formatFullDate } from '../../lib/timeFormat';

const Payment = ({ finalize, back, passengers, booking, status, meta: { countries = [] }, error }) => {
  const [showOfferCard, setShowOfferCard] = useState(false);

  const getCountryLabel = countryCode => countries.find(({ code }) => code === countryCode)?.nameAr;

  const handlePayment = ({ payLater }) => finalize({ payLater });

  return (
    <>
      {
        passengers.map(passenger => (
          <>
            <p className={styles.passenger_info_main_title}>بيانات المسافر</p>
            <div className={classNames(styles.container, styles.passenger_info)}>
              <div className={styles.passenger_info_row}>
                <div>
                  <p className={styles.passenger_info_title}>الإسم</p>
                  <p>{passenger.firstName} {passenger.lastName}</p>
                </div>

                <div>
                  <p className={styles.passenger_info_title}>الجنس</p>
                  <p>{passenger.gender === 'F' ? 'أنثى' : 'ذكر'}</p>
                </div>

                <div>
                  <p className={styles.passenger_info_title}>تاريخ الميلاد</p>
                  <p>{passenger.dateOfBirth && formatFullDate(passenger.dateOfBirth)}</p>
                </div>

                <div>
                  <p className={styles.passenger_info_title}>الجنسية</p>
                  <p>{getCountryLabel(passenger.nationalityCountry)}</p>
                </div>
              </div>
              <div className={styles.passenger_info_row}>
                <div>
                  <p className={styles.passenger_info_title}>رقم جواز السفر</p>
                  <p>{passenger.documentNumber}</p>
                </div>
                <div>
                  <p className={styles.passenger_info_title}>تاريخ إنتهاء جواز السفر</p>
                  <p>{formatFullDate(passenger.documentExpiryDate)}</p>
                </div>
                <div>
                  <p className={styles.passenger_info_title}>رقم الهاتف</p>
                  <p style={{ direction: 'ltr' }}>{booking.mobile}</p>
                </div>
              </div>
              <div className={styles.passenger_info_row}>
                <div>
                  <p className={styles.passenger_info_title}>عنوان البريد الإلكتروني</p>
                  <p>{booking.email}</p>
                </div>
              </div>
            </div>
          </>
        ))
      }

      <div className={classNames(styles.container, styles.trip_summary)}>
        <p className={styles.passenger_info_main_title}>تفاصيل رحلة السفر</p>
        {
          showOfferCard ?
            <div onClick={() => setShowOfferCard(!showOfferCard)} >
              <i className="fas fa-fw fa-chevron-up" />
            </div>
            : <div onClick={() => setShowOfferCard(!showOfferCard)} >
              <i className="fas fa-fw fa-chevron-down" />
            </div>
        }
      </div>

      {
        showOfferCard &&
        <div className='margin_bottom_16'>
          <Slices mode="detailed" baggages={booking.baggages} slices={booking.slices} tripType={booking.tripType} />
        </div>
      }

      <div className={styles.steps_indicator_buttons}>
        <button className='button simple_button' onClick={back}>
          <span className="iconify" data-icon="ic:round-chevron-right"></span>
          الخلف
        </button>
        {/* <button className='button' onClick={finalize}>
          التالي
          <FaChevronLeft />
        </button> */}
        <button className="button" onClick={() => handlePayment({ payLater: true })} disabled={status === 'submitting'}>
          التالي
          {status === 'submitting' ?
            <LoadingSpinner /> :
            <div>
              <span className="iconify" data-icon="ic:round-chevron-left"></span>
            </div>
          }
        </button>
      </div>
      {
        error &&
        <div className="error no-margin-top">
          <span className="iconify" data-icon="zondicons:exclamation-solid"></span>
          <p>نأسف, حدث خطأ غير متوقع, حاول مرة أخرى بعد قليل</p>
        </div>
      }
    </>
  );
};

export default Payment;